import React from 'react';
import { Minus, Plus } from 'lucide-react';
interface QuantitySelectorProps {
  value: number;
  onChange: (value: number) => void;
  min?: number;
  max?: number;
  label?: string;
  size?: 'sm' | 'md';
}
export function QuantitySelector({
  value,
  onChange,
  min = 1,
  max = 99,
  label = 'Quantity',
  size = 'md'
}: QuantitySelectorProps) {
  const button = size === 'sm' ? 'h-9 w-9' : 'h-12 w-12';
  const icon = size === 'sm' ? 14 : 18;
  return <div className="inline-flex items-center rounded-full border border-white/20" role="group" aria-label={label} data-id="element-274" data-mp="1fji020yfasra">
      <button type="button" onClick={() => onChange(Math.max(min, value - 1))} disabled={value <= min} aria-label="Decrease quantity" className={`${button} inline-flex items-center justify-center rounded-full text-white transition-colors duration-150 hover:bg-white hover:text-beat-black disabled:cursor-not-allowed disabled:opacity-30 disabled:hover:bg-transparent disabled:hover:text-white`} data-id="element-275" data-mp="1ohk830gkqlo2">
        <Minus size={icon} data-id="element-276" data-mp="m2ffjmj37r78" />
      </button>
      <span className={`min-w-[2.5rem] text-center text-base font-medium tabular-nums ${size === 'sm' ? 'text-sm' : ''}`} aria-live="polite" data-id="element-277" data-mp="h4vtw1k28c59">
        {value}
      </span>
      <button type="button" onClick={() => onChange(Math.min(max, value + 1))} disabled={value >= max} aria-label="Increase quantity" className={`${button} inline-flex items-center justify-center rounded-full text-white transition-colors duration-150 hover:bg-white hover:text-beat-black disabled:cursor-not-allowed disabled:opacity-30 disabled:hover:bg-transparent disabled:hover:text-white`} data-id="element-278" data-mp="77r1hjzmfkg0">
        <Plus size={icon} data-id="element-279" data-mp="3knp2dzxzeask" />
      </button>
    </div>;
}